import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { API_MAP } from '../../../core/helpers/api.map';
import { Result } from '../../../core/models/result';
import { BaseDataService } from '../../../core/services/base-data.service';
import { InternalDepartment } from '../models/internal-department.model';
import { JobSettingsProperties } from 'app/shared/components/job/models/job.model';
import { DataService } from 'app/shared/services/data.service';

@Injectable()
export class InternalDepartmentService extends BaseDataService<any> {
  override controller = API_MAP.internalDepartment;
  readonly #dataService = inject(DataService);

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }

  getJobById(id: string): Observable<Result<JobSettingsProperties>> {
      return this.#dataService.get<Result<JobSettingsProperties>>(API_MAP.jobs(id)).pipe(
        tap((d) => {
          this.content.set(d.content);
          this.components.set(d.components);
        })
      );
    }
}
